module.exports = __webpack_public_path__ + "media/images/no-image-2c716775.png";